import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=2a5c1ebe&scoped=true"
import script from "./BannerSwiper.vue?vue&type=script&lang=js"
export * from "./BannerSwiper.vue?vue&type=script&lang=js"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&id=2a5c1ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c1ebe",
  null
  
)

export default component.exports